export default {
  columns: (vm) => {
    return [{
      type: 'index',
      width: 60,
      align: 'center'
    },{
      title: '设备名称',
      key: 'UserDeviceName',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: '设备编号',
      key: 'DeviceCode',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: '告警时间',
      key: 'CreateTime',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: '告警类型',
      key: 'AbnormalName',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },{
      title: '操作',
      key: 'action',
      width: 150,
      align: 'center',
      fixed: 'right',
      render: (h, params) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'info',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.SolveAbData(params.row.Id, 2)
              }
            }
          }, '处理'),
          h('Button', {
            props: {
              type: 'warning',
              size: 'small'
            },
            on: {
              click: () => {
                vm.SolveAbData(params.row.Id, 3)
              }
            }
          }, '误报')
        ]);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/alarm/mods/detail/columns.js